import styled, { CSSProperties } from 'styled-components';
import Label from 'components/atoms/Label';
import { FC } from 'react';

const StyleFormField = styled.div`
  margin: 16px 0;
`;

interface Props {
  label?: string;
  htmlFor?: string;
  style?: CSSProperties;
  isBlock?: boolean;
}

const FormField: FC<Props> = ({ label, children, style, htmlFor, isBlock }) => (
  <StyleFormField style={{ ...style, width: isBlock ? '100%' : style?.width }}>
    {label && <Label htmlFor={htmlFor}>{label}</Label>}
    {children}
  </StyleFormField>
);

export default FormField;
